import React from 'react'
import PropTypes from 'prop-types'
import { QueryRenderer } from '@cubejs-client/react'
import Spinner from 'shared/components/common/Spinner/Spinner.component'
import { createCubeJsApi } from 'shared/utils/cubejsApi'
import BarChart from '../BarChart/BarChart.component'
import LineChart from '../LineChart/LineChart.component'
import TableChart from '../TableChart/TableChart.component'
import SentimentsChart from '../SentimentsChart/SentimentsChart.component'
import queryBuilder from 'shared/utils/chart/queryBuilder'

import styles from './Chart.module.scss'

const renderChart = (Component, props) => ({ resultSet, loadingState, error }) => {
  error && console.error(error)

  if(resultSet?.loadResponse?.data?.length === 0) {
    return <span className={styles.noDataTitle}>No data was found</span>
  }

  if(
    !resultSet ||
    loadingState?.isLoading
  ) {
    return <Spinner visible />
  }

  return <Component resultSet={resultSet} {...props} />
}

const ChartRenderer = props => {
  const {
    granularity,
    dateRange,
    customDateRange,
    chartType,
    channelNameToFilter,
    table,
    timeDimension,
    measures,
    filters,
    dimensions,
    agentId,
    organisationId,
    token,
    druid
  } = props

  let cubejsApi

  if(
    agentId &&
    agentId !== 'default' &&
    organisationId &&
    token
  ) {
    cubejsApi = createCubeJsApi({
      agentId,
      organisationId,
      token,
      druid
    })
  } else {
    return <Spinner visible />
  }

  let chartComponent = null

  switch(chartType) {
    case 'bar': {
      chartComponent = BarChart
      break
    }

    case 'line': {
      chartComponent = LineChart
      break
    }

    case 'sentiments': {
      chartComponent = SentimentsChart
      break
    }

    case 'table': {
      chartComponent = TableChart
      break
    }
  }

  const query = queryBuilder({
    agentId,
    table,
    timeDimension,
    granularity,
    dateRange,
    chartType,
    customDateRange,
    channelNameToFilter,
    measures,
    filters,
    dimensions
  })

  return <QueryRenderer
    query={query}
    cubejsApi={cubejsApi}
    render={renderChart(chartComponent, props)}
  />
}

ChartRenderer.defaultProps = {
  druid: false
}

/* eslint-disable react/no-unused-prop-types */
ChartRenderer.propTypes = {
  druid: PropTypes.bool,
  table: PropTypes.string,
  timeDimension: PropTypes.string,
  measures: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  filters: PropTypes.array,
  dimensions: PropTypes.array,
  tooltipDimension: PropTypes.string,
  chartType: PropTypes.string,
  granularity: PropTypes.string,
  dateRange: PropTypes.string,
  customDateRange: PropTypes.object,
  channelNameToFilter: PropTypes.string,
  onChangeChartType: PropTypes.func,
  onChangeGranularity: PropTypes.func,
  onMoveCustomDateRange: PropTypes.func,
  tableDataMapHandler: PropTypes.func,
  agentId: PropTypes.string,
  organisationId: PropTypes.string,
  token: PropTypes.string,
  customColorMapper: PropTypes.func,
  customTitleDimensionMapper: PropTypes.func,
  dataPreAggregator: PropTypes.func
}
export default ChartRenderer
